<template>
    <div class="o-schedule-sk">
        <img :src="scheduleImage" alt="schedule">
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "OScheduleSK",
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        componentParams() {
            return this.getMapConfigProp('components.OScheduleSK.params') || {};
        },
        scheduleImage() {
            return this.componentParams.schedule_image || 'https://fs.mvgcloud.com/51594259/55633981.png'
        }
    }
}
</script>

<style lang="scss">
@import "theme";
</style>
